import { Component, Input, ViewContainerRef } from '@angular/core';
import { MembershipCardComponent } from '../membership-card/membership-card.component';
import { MembershipCard } from '../membership-card/models/membership-card.interfaces';
import { QuickLinks } from './models/quick-links.interfaces';

@Component({
  selector: 'idp-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrls: ['./quick-links.component.scss']
})
export class QuickLinksComponent {
  @Input() content: QuickLinks = {} as QuickLinks;

  constructor(public viewContainerRef: ViewContainerRef) {}

  createMemberShipCard(membershipCard: MembershipCard) {
    const componentRef = this.viewContainerRef.createComponent(
      MembershipCardComponent
    );
    componentRef.instance.content = !membershipCard.image.src.includes(
      window.location.origin
    )
      ? this.updateCardUrls(membershipCard)
      : membershipCard;
  }

  updateCardUrls(membershipCard: MembershipCard): MembershipCard {
    membershipCard.image.src =
      window.location.origin + membershipCard.image.src;
    membershipCard.barcode.src =
      window.location.origin + membershipCard.barcode.src;
    return membershipCard;
  }
}
